import React from "react";

export default React.createContext({
    mapUrl: Object
});